import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getFormPackets } from 'api/Forms';

export const useFormPackets = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['form_packets', ...dependencies], () => getFormPackets(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    ...options
  });
};
